module.exports = __webpack_public_path__ + "static/media/icon-live-stats-goal.76e16ccd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-live-stats-goal.svg
// module id = ./src/assets/images/icon-live-stats-goal.svg
// module chunks = 6